import React from 'react';

// Organic Tech Icons - Thin line style with organic curves
export const LeafIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M6 3c5.5 2.5 8.5 6.5 9 12.5-3.5-2-6.5-5-9-7.5 0-2.5 0-3.5 0-5z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 8c2.5 1.5 4.5 3.5 5.5 6.5-2-1.5-4-3-5.5-4.5 0-1 0-1.5 0-2z" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const BrainIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M9.5 2C6.5 2 4 4.5 4 7.5c0 2 1 3.5 2.5 4.5M14.5 2c3 0 5.5 2.5 5.5 5.5 0 2-1 3.5-2.5 4.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 7.5c0 2-1 3.5-2.5 4.5M12 7.5c0 2 1 3.5 2.5 4.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.5 12c2 0 3.5 1 4.5 2.5M14.5 12c-2 0-3.5 1-4.5 2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 16.5c-1.5 1-2.5 2.5-2.5 4.5M12 16.5c1.5 1 2.5 2.5 2.5 4.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const RocketIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M4.5 16.5c-1.5-1.5-2-3-2-4.5s.5-3 2-4.5l3-3c1.5-1.5 3-2 4.5-2s3 .5 4.5 2l3 3c1.5 1.5 2 3 2 4.5s-.5 3-2 4.5l-3 3c-1.5 1.5-3 2-4.5 2s-3-.5-4.5-2l-3-3z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 8l-2 4 2 4 2-4-2-4z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 12h8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ClockIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 12c0-3.3 2.7-6 6-6" strokeLinecap="round" strokeLinejoin="round" opacity="0.3"/>
  </svg>
);

export const SparkleIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M12 2l3 7 7 3-7 3-3 7-3-7-7-3 7-3z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2l-3 7-7 3 7 3 3 7 3-7 7-3-7-3z" strokeLinecap="round" strokeLinejoin="round" opacity="0.5"/>
  </svg>
);

export const WaveIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M2 12c2-4 4-6 6-6s4 2 6 6 4 6 6 6 4-2 6-6" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 16c2-2 4-3 6-3s4 1 6 3 4 3 6 3 4-1 6-3" strokeLinecap="round" strokeLinejoin="round" opacity="0.5"/>
  </svg>
);

export const DiamondIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M12 2l8 10-8 10-8-10 8-10z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2l-8 10 8 10" strokeLinecap="round" strokeLinejoin="round" opacity="0.3"/>
  </svg>
);

export const FlowerIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <circle cx="12" cy="12" r="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2c0 2-1 3-3 3s-3-1-3-3 1-3 3-3 3 1 3 3z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 12c0-2-1-3-3-3s-3 1-3 3 1 3 3 3 3-1 3-3z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 22c-2 0-3-1-3-3s1-3 3-3 3 1 3 3-1 3-3 3z" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2 12c2 0 3-1 3-3s-1-3-3-3-3 1-3 3 1 3 3 3z" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ArrowRightIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M5 12h14" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CheckIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CloseIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M18 6L6 18" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 6l12 12" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const MenuIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M3 12h18" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 6h18" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 18h18" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const XIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M18 6L6 18" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 6l12 12" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const DownloadIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="7,10 12,15 17,10" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="15" x2="12" y2="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const MailIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="22,6 12,13 2,6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
); 